import { ActionList, Button, Popover } from "@shopify/polaris";
import {
    CircleCancelMajorMonotone,
    EditMajorMonotone,
} from "@shopify/polaris-icons";
import React, { Fragment, useCallback, useReducer } from "react";
import { arrInvalid, reducerFn } from "../../helper";
import ChannelTeamDelete from "./actions/channel-team-delete";
import ChannelTeamUpdate from "./actions/channel-team-update";

export default function ChannelTeamAction({ node }) {
    const [state, setState] = useReducer(reducerFn, {
        open: false,
        action: null,
        active: false,
    });

    const handleClose = useCallback(() => {
        setState({ open: false, active: false, action: null });
    }, []);

    const handleToggle = useCallback(() => {
        setState((p) => ({
            ...p,
            active: !p.active,
        }));
    }, []);

    const handleClick = useCallback(
        (type) => () => {
            setState({ open: true, action: type });
        },
        [],
    );

    const props = {
        node,
        ids: [node.id],
        open: state.open,
        onClose: handleClose,
    };

    const actions = [
        {
            content: "Update",
            icon: EditMajorMonotone,
            onAction: handleClick("update"),
        },
        {
            content: "delete",
            icon: CircleCancelMajorMonotone,
            onAction: handleClick("delete"),
        },
    ].filter(Boolean);

    const actionMarkup = {
        update: <ChannelTeamUpdate {...props} />,
        delete: <ChannelTeamDelete {...props} />,
    };

    const activator = (
        <Button
            children="Actions"
            disclosure
            onClick={handleToggle}
            disabled={arrInvalid(actions)}
        />
    );

    return (
        <Fragment>
            <Popover
                activator={activator}
                onClose={handleToggle}
                active={state.active}
            >
                <ActionList items={actions} />
            </Popover>

            {actionMarkup[state.action]}
        </Fragment>
    );
}
